import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import SimpleMantenedorLayout from '../../../components/SimpleMantenedorLayout'
import ExtrasTable from '../../../components/Extras/ExtrasTable'
import NuevoExtraModal from '../../../components/Extras/NuevoExtraModal'
import { useExtras } from '../../../hooks/useExtras'
import { useMantenedores } from '../../../context/MantenedoresContext'
import * as FaIcons from 'react-icons/fa'
import { Button, Alert, Form, InputGroup } from 'react-bootstrap'
import TextField from '@mui/material/TextField'

const ListaExtras = () => {
    const user = useSelector(state => state.auth.user)
    const { userPermissions } = useMantenedores()
    const [showModal, setShowModal] = useState(false)

    const {
        extras,
        tiposExtra,
        total,
        loading,
        error,
        searchValue,
        tipoExtraId,
        handleSearchValue,
        handleTipoExtraChange,
        refetch
    } = useExtras(user, userPermissions)

    const canCreate = userPermissions?.modules?.extras?.canAdmin || false

    const handleShowModal = () => setShowModal(true)
    const handleCloseModal = () => setShowModal(false)

    const handleExtraCreated = () => {
        handleCloseModal()
        refetch()
    }

    return (
        <SimpleMantenedorLayout
            mantenedorId="extras"
            title="Lista de Extras"
            subtitle="Catálogo de extras disponibles para asignación"
            iconColor="#e17055"
            breadcrumbs={[{ label: 'Extras', path: '/mantenedores/extras' }, { label: 'Lista' }]}
            showBackButton={false}>
            <div style={{ padding: '10px' }}>
                {/* Filtros y botones */}
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginBottom: '15px',
                        flexWrap: 'wrap',
                        gap: '15px'
                    }}>
                    {/* Filtros */}
                    <div
                        style={{
                            display: 'flex',
                            gap: '10px',
                            alignItems: 'center',
                            flex: 1,
                            height: '38px' // Altura fija para alineación
                        }}>
                        {/* Búsqueda por texto */}
                        <div style={{ minWidth: '300px' }}>
                            <TextField
                                type="text"
                                placeholder="Buscar extra..."
                                value={searchValue}
                                onChange={e => handleSearchValue(e.target.value)}
                                size="small"
                                variant="outlined"
                                fullWidth
                                InputProps={{
                                    startAdornment: (
                                        <FaIcons.FaSearch
                                            style={{ fontSize: '18px', color: '#6c757d', marginRight: 8 }}
                                        />
                                    ),
                                    style: { height: 38, alignItems: 'center' }
                                }}
                            />
                        </div>

                        {/* Filtro por tipo de extra */}
                        <div style={{ minWidth: '200px' }}>
                            <Form.Select
                                value={tipoExtraId || ''}
                                onChange={e => handleTipoExtraChange(e.target.value || null)}
                                style={{ height: '38px' }}>
                                <option value="">Todos los tipos</option>
                                {tiposExtra.map(tipo => (
                                    <option key={tipo.id} value={tipo.id}>
                                        {tipo.tipo.toUpperCase()}
                                    </option>
                                ))}
                            </Form.Select>
                        </div>
                    </div>

                    {/* Botón crear nuevo */}
                    {canCreate && (
                        <Button
                            variant="success"
                            onClick={handleShowModal}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                                whiteSpace: 'nowrap',
                                height: '38px',
                                padding: '6px 16px'
                            }}>
                            <FaIcons.FaPlus style={{ fontSize: '14px' }} />
                            Nuevo Extra
                        </Button>
                    )}
                </div>

                {/* Mensaje de error */}
                {error && (
                    <Alert variant="danger" style={{ marginBottom: '20px' }}>
                        {error}
                    </Alert>
                )}

                {/* Tabla */}
                <ExtrasTable extras={extras} loading={loading} total={total} />

                {/* Modal para crear nuevo extra */}
                <NuevoExtraModal
                    show={showModal}
                    onHide={handleCloseModal}
                    onExtraCreated={handleExtraCreated}
                    user={user}
                    tiposExtra={tiposExtra}
                />
            </div>
        </SimpleMantenedorLayout>
    )
}

export default ListaExtras
